import {Link} from "react-router-dom"

const SurveyDropdownMenu = (props) => {
    return (
        <div className="d-flex menu menu-sub menu-sub-dropdown menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px">
            <div className="menu-item px-5">
                <Link to="/surveys/new-hire-status-report-selection" className="menu-link rounded-2">
                    <i className="fas text-primary fs-1 w-30px flex-center h-30px me-2 fa-user-nurse"></i>
                    <span className="d-flex flex-column flex-grow-1">
                        <span className="fs-5 fw-bold text-gray-800">New Hire Status Report</span>
                        <span className="fs-7 fw-semibold text-gray-800">Report your current orientation status.</span>
                    </span>
                </Link>
            </div>
            <div className="menu-item px-5">
                <Link to="/surveys/orientation-status-report-selection" className="menu-link rounded-2">
                    <i className="fas text-primary fs-1 w-30px flex-center h-30px me-2 fa-clipboard-user"></i>
                    <span className="d-flex flex-column flex-grow-1">
                        <span className="fs-5 fw-bold text-gray-800">Orientation Status Report</span>
                        <span className="fs-7 fw-semibold text-gray-800">Preceptor assessment of an orientee.</span>
                    </span>
                </Link>
            </div>
        </div>
    )
}

export default SurveyDropdownMenu
